<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="messageClasses"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    /**
     * Allows the selection of a hotel ID by choosing its name or code from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-messageClass',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                messageClasses: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getMessageClasses();
        },
        methods: {
            getMessageClasses:function(){
                axios.get('/api/selectable-message-classes')
                .then(function(response){
                    console.log(response);
                    var messageClasses = [];
                    response.data.forEach(function(messageClass){
                        messageClasses.push({ text: messageClass.name, value: messageClass.message_class_value });
                    });
                    this.messageClasses = messageClasses;
                }.bind(this));
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
